<canvas #overlayCanvas class="video-overlay-canvas"></canvas>
<!-- <button (click)="makedrawing()"> click to add drawing... </button> -->